
/**
 * 颜色解析函数
 * @param {*} color 
 */
export function parseColor(color, config) {
  const themeColors = config?.themeColors || `var(--theme-${color?.themeColorId || "default"}-${color?.colorOpacity ?? 100})`
  const themeColor = typeof themeColors === 'string' ? themeColors : (color?.themeColorId ? themeColors.find((item) => item.id === color?.themeColorId)?.value : themeColors[0].value)
  if (!color) {
    return config?.isThemeColor ? themeColor : ''
  }
  if (typeof color === 'string') return config.isThemeColor ? themeColor : color
  if (!Object.prototype.toString.call(color) === '[object Object]') return color
  // 是否有主题色的几个配置场景
  const isThemeColor = color.hasOwnProperty('themeColorId') ? 
    color.isThemeColor : (config.hasOwnProperty('isThemeColor') ? config?.isThemeColor : (color?.isThemeColor ?? false))
  if (!isThemeColor) {
    if (color?.type === 'color' || !color?.type) return color?.color || color?.data?.stops?.[0]?.[0]
    if (['linearGradient', 'radialGradient'].includes(color?.type)) return pasrseColorStops(color, config)
  }
  if (isThemeColor) {
    const colorRenderModel = config?.renderModel ||  'value'
    if (colorRenderModel === 'variable') {
      // 解析成颜色变量
      return `var(--theme-${color?.themeColorId || "default"}-${color?.colorOpacity ?? 100})`
    } else {
      return themeColor ? getLightnessColors(themeColor, color?.colorOpacity ?? 100) : color
    }
  }
}


function pasrseColorStops(color, config) {
  const stopDatas = color?.data?.stops
  if (!stopDatas) return color
  const stops = stopDatas.map(([startColor, endValue, themeConfig]) => {
    return [themeConfig && themeConfig?.isThemeColor ? parseColor(themeConfig, config) : startColor, endValue]
  })
  if (color?.type === 'linearGradient') {
    return `linear-gradient(${color?.data?.angle}deg, ${stops.map(([startColor, endValue]) => `${startColor} ${endValue * 100}%`).join(', ')})`
  } else if (color?.type === 'radialGradient') {
    const siteX = color?.data?.siteX ? color?.data?.siteX : 0
    const siteY = color?.data?.siteY ? color?.data?.siteY : 0
    return `radial-gradient(circle at ${siteX}% ${siteY}%, ${stops.map(([startColor, endValue]) => `${startColor} ${endValue * 100}%`).join(', ')})`
  }
}
export function parseColorString(color) {
  if (typeof color === 'string') {
    // 处理十六进制颜色
    if (color.startsWith('#')) {
      return color
    }
    // 处理 rgb(a) 颜色
    const rgbMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (rgbMatch) {
      const [, r, g, b, a] = rgbMatch.map(Number);
      return '#' + 
      (r).toString(16).padStart(2,'0') + 
      (g).toString(16).padStart(2,'0') + 
      (b).toString(16).padStart(2,'0')
    }
  }
}

export function getLightnessColors(themeColor, opacity) {
  if (themeColor?.startsWith('#')) 
    themeColor = themeColor?.slice(0, 7)
  if (themeColor?.startsWith('rgb'))
    themeColor = parseColorString(themeColor)
  // 解析主题色为RGB分量
  // 去除可能包含的#号并转为大写
  const cleanedHex = themeColor.replace(/^#/, '').toUpperCase();
  // 将透明度转换为0-255的整数，并确保在范围内
  const alpha = Math.round((opacity / 100) * 255);
  const clampedAlpha = Math.min(255, Math.max(0, alpha));
  
  // 转换为两位十六进制字符串，并补零
  const alphaHex = clampedAlpha.toString(16).padStart(2, '0').toUpperCase();
  
  // 拼接成八位十六进制颜色值
  return `#${cleanedHex}${alphaHex}`;
}


// export function getLightnessColors(themeColor, alpha) {
//   if (themeColor?.startsWith('rgb'))
//   themeColor = parseColorString(themeColor)
//   // 解析主题色为RGB分量
//   alpha = alpha / 100
//   let hex = themeColor.replace('#', '');
//   if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
//   const r = parseInt(hex.substring(0, 2), 16);
//   const g = parseInt(hex.substring(2, 4), 16);
//   const b = parseInt(hex.substring(4, 6), 16);

//   // 计算混合后的RGB值
//   const blend = (channel) => Math.round((1 - alpha) * 255 + alpha * channel);
//   const blendedR = blend(r);
//   const blendedG = blend(g);
//   const blendedB = blend(b);

//   // 返回十六进制或RGB格式
//   return `#${[blendedR, blendedG, blendedB].map(c => c.toString(16).padStart(2, '0')).join('')}`;
// }

export function  getDarknessColors(color, alpha = 0) {
  // 解析颜色为RGBA格式
  const parseColor = (color) => {
      // 处理十六进制颜色
      if (color.startsWith('#')) {
          const hex = color.slice(1);
          if ([3, 4, 6, 8].includes(hex.length)) {
              let r, g, b, a = 1;
              if (hex.length <= 4) {
                  // 扩展简写形式（如#rgb到#rrggbb）
                  const expand = hex.split('').map(c => c + c).join('');
                  [r, g, b] = expand.match(/.{2}/g).map(v => parseInt(v, 16));
              } else {
                  [r, g, b] = hex.match(/.{2}/g).map(v => parseInt(v, 16));
              }
              return { r, g, b, a };
          }
      }

      // 处理RGB/RGBA颜色
      const rgbaMatch = color.match(/^rgba?$(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?$$/i);
      if (rgbaMatch) {
          const r = parseInt(rgbaMatch, 10);
          const g = parseInt(rgbaMatch, 10);
          const b = parseInt(rgbaMatch, 10);
          const a = rgbaMatch ? parseFloat(rgbaMatch) : 1;
          return { r, g, b, a };
      }

      throw new Error('Invalid color format');
  };

  // 解析输入颜色
  const { r, g, b, a: originalAlpha } = parseColor(color);
  const overlayAlpha = alpha / 100; // 将百分比转换为小数

  // 计算混合后的Alpha通道
  const blendedAlpha = originalAlpha + overlayAlpha * (1 - originalAlpha);
  
  // 计算混合后的RGB通道（应用Alpha叠加公式）
  const blend = (channel) => Math.round(
      (channel * originalAlpha * (1 - overlayAlpha)) / blendedAlpha
  );

  // 确保数值在0-255范围内
  const clamp = (num) => Math.min(255, Math.max(0, num));

  // 生成结果颜色
  return `rgba(${clamp(blend(r))}, ${clamp(blend(g))}, ${clamp(blend(b))}, ${blendedAlpha.toFixed(2)})`;
}

export function rgbaToHex(r, g, b, a = 1) {
  const hex = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
  if(a === 1) return hex
  
  const alpha = Math.round(a * 255).toString(16)
  return `${hex}${alpha.padStart(2, '0')}`
}

function getColorFromString(color) {
  // 转换hex为rgb
  if(color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16)
    const g = parseInt(color.slice(3, 5), 16) 
    const b = parseInt(color.slice(5, 7), 16)
    return {r, g, b}
  }
  const rgbMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (rgbMatch) {
    const [, r, g, b, a] = rgbMatch.map(Number);
    return {r, g, b}
  }
}

/**
 * 为颜色添加透明度
 * @param {string} color - 颜色值,支持 hex 格式
 * @returns {Array} 包含透明度0-100的颜色数组
 */
export function getColorOpacityObject(color) {
  // 移除 # 号
  const {r, g, b} = getColorFromString(color)
  const opacityColors = {}
  for(let opacity = 0; opacity <= 100; opacity++) {
    opacityColors[`--theme-default-${opacity}`] = getLightnessColors(color, opacity)
  }
  return opacityColors
}